import { combineReducers } from 'redux'
import forms from './forms'
import ui from './ui'
import general from './general'
import cotizador from './cotizador'
import { sessionReducer } from 'redux-react-session';
// import notifyReducer from 'react-redux-notify';

export default combineReducers({
    forms,
    ui,
    general,
    cotizador,
    session: sessionReducer,
    // notifications: notifyReducer 
})